export const TARGET_BLANK = '_blank'
export const TARGET_SELF = '_self'
// eslint-disable-next-line no-script-url
export const URL_JAVASCRIPT_VOID = 'javascript:void(0)'

/**
 * Used on html element data-action to indicate a continue action
 * @type {string}
 */
export const DATA_ACTION_CONTINUE = 'continue'
